import React from 'react';
import { motion } from 'framer-motion';
import { ResearchFocus } from '../components/ResearchFocus';
import { ResearchApproach } from '../components/ResearchApproach';
export function Research() {
  const areas = [{
    title: 'Multiphase Flow Modelling',
    category: 'Fundamental Studies',
    image: 'https://images.unsplash.com/photo-1518104593124-ac2e82a5eb9b?auto=format&fit=crop&q=80&w=600'
  }, {
    title: 'Flow Boiling in Microchannel Heat Sink',
    category: 'Fundamental Studies',
    image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&q=80&w=600'
  }, {
    title: 'Spray Cooling',
    category: 'Fundamental Studies',
    image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?auto=format&fit=crop&q=80&w=600'
  }, {
    title: 'Machine Learning Techniques',
    category: 'Fundamental Studies',
    image: 'https://images.unsplash.com/photo-1555949963-aa79dcee981c?auto=format&fit=crop&q=80&w=600'
  }, {
    title: 'Electronics Cooling',
    category: 'Application Studies',
    image: 'https://images.unsplash.com/photo-1591799264318-7e6ef8ddb7ea?auto=format&fit=crop&q=80&w=600'
  }, {
    title: 'Battery Thermal Management',
    category: 'Application Studies',
    image: 'https://images.unsplash.com/photo-1620288627223-53302f4e8c74?auto=format&fit=crop&q=80&w=600'
  }];
  return <div className="bg-[#FAF9F7] min-h-screen pb-24" data-id="element-420">
      <div className="bg-[#4A0000] py-16 text-center" data-id="element-421">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-4xl md:text-5xl font-bold text-white font-serif" data-id="element-422">
          Research Areas
        </motion.h1>
      </div>

      <ResearchApproach data-id="element-423" />
      <ResearchFocus data-id="element-424" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-16" data-id="element-425">
        <h2 className="text-3xl font-bold text-[#800000] font-serif mb-12 text-center" data-id="element-426">
          Detailed Research Topics
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-427">
          {areas.map((area, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-xl overflow-hidden shadow-sm border border-gray-100 hover:shadow-md transition-all group" data-id="element-428">
              <div className="h-48 overflow-hidden relative" data-id="element-429">
                <div className="absolute inset-0 bg-[#4A0000]/20 group-hover:bg-transparent transition-colors z-10" data-id="element-430"></div>
                <img src={area.image} alt={area.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-431" />
              </div>
              <div className="p-6" data-id="element-432">
                <span className="text-xs font-bold text-[#800000] uppercase tracking-wider mb-2 block" data-id="element-433">
                  {area.category}
                </span>
                <h3 className="text-xl font-bold text-gray-900 font-serif" data-id="element-434">
                  {area.title}
                </h3>
              </div>
            </motion.div>)}
        </div>
      </div>
    </div>;
}